/* eslint-disable camelcase, import/prefer-default-export  */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/delete';

type p5_role_id = string | string[] //  角色GUID

export interface request {
  p5_role_id: p5_role_id,
}

export interface AxiosResponse extends AxiosResponse<responseData> { }

interface responseData extends backendResponse {
  response: any
}
